import { useEffect } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { useAuth } from "@/lib/AuthContext";
import { useTheme } from "@/lib/ThemeContext";
import { track } from "@/lib/analytics";

// Bundle E-4: landing page for the verification link (public; the API redirects here with ?status=).
export default function VerifiedPage() {
  const { tokens: t } = useTheme();
  const { user, refreshUser } = useAuth();
  const [params] = useSearchParams();
  const ok = params.get("status") === "verified";
  useEffect(() => { if (ok) { track("email_verified"); refreshUser?.(); } }, [ok, refreshUser]);
  return (
    <div className="min-h-screen flex items-center justify-center px-6" style={{ background: t.bgPrimary, color: t.textPrimary }} data-testid="verified-page">
      <div className="max-w-sm space-y-4">
        <h1 className="text-2xl font-bold" data-testid="verified-heading">{ok ? "Email verified" : "That link has expired"}</h1>
        <p className="text-sm leading-relaxed" style={{ color: t.textMuted }}>
          {ok ? "Thanks — your address is confirmed, so you'll always be able to get back into your account." : "Verification links work for 48 hours and once only. Sign in and choose Resend to get a fresh one."}
        </p>
        <Link to={user ? "/" : "/login"} className="inline-block text-sm font-semibold hover:underline" style={{ color: t.accent }} data-testid="verified-continue">
          {ok ? "Continue" : "Sign in"}
        </Link>
      </div>
    </div>
  );
}
